import React, { useEffect, useState } from "react";
import useButtonStyles from "../../styles/useButtonStyles";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Drawer,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
} from "@mui/material";
import theme from "../../theme";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import AddShopUserForm from "./AddShopUserForm";
import formatDate from "../../util/dateFormat";
import axios from "axios";
import { APIConstants, APIModuleConstants } from "../../constants/ApiConstants";
import { useAppSelector } from "../../redux/hooks";
import { useParams } from "react-router-dom";
import { operatorConstants } from "../../util/SearchandFIlters/Constants";
import { getHashURL } from "../../util/SearchandFIlters/searchAndFilter";
import InfiniteTable from "../Table/InfiniteScroll/InfiniteTable";
import { getFeaturePermissions } from "../../util/permissions";
import useGetTotalRecords from "../../Hooks/CustomHooks/UseGetTotalRecords";
import { SearchToolTip, filterConstants } from "../../constants/AppConstants";
import SearchInput from "../../Shared/Components/SearchInput/SearchInput";
import { getEncodedValue } from "../forms/utility";
import { usePermissionGetter } from "../../Hooks/Permissions/userPermissionGetter";

interface TableColumn {
  key: string;

  header: string;

  searchable?: boolean;

  filterable?: boolean;
}
const listOfStatus = [filterConstants.Active, filterConstants.Inactive];
const ViewMerchantShopUser = () => {
  const columns: TableColumn[] = [
    { key: "name", header: "Name" },
    { key: "email", header: "Email" },
    { key: "mobileNumber", header: "Mobile Number" },
    { key: "merchant", header: "Merchant" },
    { key: "companyName", header: "Company Name" },
    { key: "role", header: "Role" },
    { key: "status", header: "Status" },
  ];
  const { getUserPermission: getMerchantReceiptPermission } =
    usePermissionGetter("merchant", "shop_user");
  const [data, setData] = useState([]);
  const [openFilter, setOpenFilter] = useState(false);
  const [loading, setLoading] = useState(false);
  const [lastKey, setLastKey] = useState(null);
  const [canAddMoreData, setAddMoreData] = useState(false);
  const [initialApiCall, setInitialApiCall] = useState(true);
  const [filterActive, setFilterActive] = useState(false);
  const params = useParams();
  const { merchantId } = params;
  const [openAddShopUser, setAddShopUser] = useState(false);
  const { totalCount, getTotalRecordsCount } = useGetTotalRecords();
  const buttonStyles = useButtonStyles();
  const [roles, setRoles] = useState<string[]>([]);
  useEffect(() => {
    const fetchRoleList = async () => {
      try {
        const response = await axios.get(
          process.env.REACT_APP_API_URL + APIConstants.role + "?type=Merchant"
        );
        const data = response.data.data;

        const roleListData = data.map((item: any) => {
          return {
            name: item.name ? item.name : "-",
            description: item.description ? item.description : "-",
          };
        });

        const roles = data.map((item: any) => {
          return item.name;
        });
        setRoles(roles);
      } catch (error) {
        console.error(error);
      }
    };

    fetchRoleList();
  }, []);
  const handleClose = () => {
    setOpenFilter(false);
  };
  const entireList = useAppSelector(
    (state: any) => state.persistReducers.getMerchantList.entireListOfMerchants
  );

  const merchantListFromRedux = entireList.map((entity: any) => {
    return {
      id: entity.id,
      label: entity.name,
      external_id: entity.external_id,
    };
  });
  const external_id = merchantListFromRedux.find(
    (ele: any) => ele.id === merchantId
  )?.external_id;
  const fetchShopUserList = async (
    urlString?: string,
    canHaveExistingData?: boolean
  ) => {
    let moduleName = "module=merchant&feature=shop_user";
    let currentURl = `${process.env.REACT_APP_API_URL + APIConstants.admin}`;
    if (urlString) {
      currentURl += `?${urlString}`;
    }
    currentURl += (currentURl.includes("?") ? "&" : "?") + moduleName;

    try {
      setLoading(true);
      if (lastKey) {
        currentURl += `&lastKey=${encodeURIComponent(JSON.stringify(lastKey))}`;
      }
      if (!data.length)
        getTotalRecordsCount(APIModuleConstants.adminUser, urlString);
      const response = await axios.get(currentURl);
      const apidata = response.data.result.data;
      const lastData = response?.data?.result?.lastKey;
      setLastKey(lastData ? lastData : null);
      const shopUserlistData = apidata.map((item: any) => {
        return {
          email: item.email ? item.email : "-",
          name: item.firstName ? `${item.firstName} ${item.lastName}` : "-",
          status: item.status ? item.status : "-",
          role: item.user_role ? item.user_role : "-",
          department: item.department ? item.department : "-",
          merchant: item.merchant ? item.merchant : "-",
          mobileNumber: item.mobile ? item.mobile : "-",
          companyName: item.companyName ? item.companyName : "-",
          lastLogin: item.lastLogin ? formatDate(item.lastLogin) : "-",
        };
      });
      const dataToSet = canHaveExistingData
        ? [...data, ...shopUserlistData]
        : shopUserlistData;
      setData(dataToSet);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
      setAddMoreData(false);
      // setError(true);
    } finally {
      setLoading(false);
      setAddMoreData(false);
    }
  };
  useEffect(() => {
    if (canAddMoreData) bindSearchAndFilter();
  }, [canAddMoreData]);

  // filter and search UI
  const searchInputRef = React.useRef<HTMLInputElement>();

  const bindSearchAndFilter = (canHaveExistingData?: boolean) => {
    const hashValue = {
      field: "userType",
      value: "merchant",
    };
    const value = searchInputRef.current
      ? getEncodedValue(searchInputRef.current?.value)
      : "";
    const searchParam = value !== "" ? [value] : [];
    const params = {
      hashData: hashValue,
      searchData: searchParam,
      filterData: filterStates,
    };
    const url = getHashURL(params);
    const apiCall = Boolean(!canHaveExistingData);
    fetchShopUserList(url, canHaveExistingData);
    setInitialApiCall(false);
    return url;
  };
  const [filterState, setFilterState] = useState({
    userRole: "",
    status: "",
  });

  const resetFilterState = () => {
    setFilterState({
      userRole: "",
      status: "",
    });
    setFilterStates([
      {
        fieldValue: "merchant_ext_id",
        value: `${external_id}`,
        operator: "contains",
      },
    ]);
    setFilterActive(false);
    onReset()
  };
  const [filterStates, setFilterStates] = useState<any>([
    {
      fieldValue: "merchant_ext_id",
      value: `${external_id}`,
      operator: "contains",
    },
  ]);

  const getAllFields = (fieldValue: any, value: any, operator?: any) => {
    const existingObject = filterStates.find(
      (obj: any) => obj.fieldValue === fieldValue
    );

    if (!existingObject) {
      setFilterStates((prev: any) => [
        ...prev,
        { fieldValue: fieldValue, value: value, operator: operator },
      ]);
    } else {
      setFilterStates((prev: any) =>
        prev.map((obj: any) =>
          obj.fieldValue === fieldValue
            ? { ...obj, value: value, operator: operator }
            : obj
        )
      );
    }
  };

  const HandleRoleChange = (event: SelectChangeEvent) => {
    getAllFields(
      "user_role",
      (event.target as HTMLSelectElement).value,
      operatorConstants.equal
    );
    setFilterState((prev) => ({
      ...prev,
      userRole: event.target.value,
    }));
  };
  const HandleStatusChange = (event: SelectChangeEvent) => {
    getAllFields(
      "status",
      (event.target as HTMLSelectElement).value,
      operatorConstants.equal
    );
    setFilterState((prev) => ({
      ...prev,
      status: event.target.value,
    }));
  };
  const applyShopUserFilter = () => {
    onReset()
    setOpenFilter(false);
    const newFilterState = filterStates.slice(1);
    newFilterState && setFilterActive(true);
  };
  // search

  const onReset = () => {
    setData([]);
    setLastKey(null);
    setInitialApiCall(true);
  };
  const handleSearch = () => {
    onReset();
  };

  const permissions = useAppSelector(
    (state: any) => state.persistReducers.login.permissions
  );

  useEffect(() => {
    if (initialApiCall) bindSearchAndFilter();
  }, [initialApiCall]);

  return (
    <Grid
      sx={{ background: theme.color?.background, borderRadius: "16px" }}
      display={"flex"}
      flexDirection={"column"}
      overflow={"hidden"}
      width={"100%"}
    >
      <Drawer
        anchor={"right"}
        open={openAddShopUser}
        onClose={() => {
          setAddShopUser(false);
        }}
        sx={{
          "& .MuiPaper-root": {
            borderRadius: "16px 0 0 16px",
          },
        }}
      >
        <Grid width={"642px"} height={"100%"}>
          <AddShopUserForm closeDrawer={setAddShopUser} onRefresh={() => onReset()} />
        </Grid>
      </Drawer>
      <Dialog onClose={handleClose} open={openFilter} sx={{ ml: "60vw" }}>
        <Grid sx={{ width: "484px", py: 4, px: 2 }}>
          <DialogTitle
            display={"flex"}
            justifyContent={"space-between"}
            borderBottom={theme.border?.smallGrey}
          >
            <Typography
              sx={{
                fontFamily: theme.font?.fontFamily.primary,
                color: theme.color?.primary,
                fontSize: theme.font?.fontSize.large,
                fontWeight: theme.font?.fontWeight.thicker,
              }}
            >
              Filter
            </Typography>
            {/* <IconButton onClick={() => setOpenFilter(false)}> */}
            <IconButton
              onClick={() => {
                setOpenFilter(false);
              }}
            >
              <CloseOutlinedIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ borderBottom: theme.border?.smallGrey }}>
            <Grid>
              <Grid borderBottom={theme.border?.smallGrey} mt={5}>
                <Typography
                  sx={{
                    fontFamily: theme.font?.fontFamily.primary,
                    fontSize: theme.font?.fontSize.medium,
                    fontWeight: theme.font?.fontWeight.thick,
                  }}
                >
                  Status
                </Typography>
                <Grid
                  gap={2}
                  mt={2}
                  display={"flex"}
                  sx={{
                    width: "80%",
                  }}
                >
                  <FormControl
                    fullWidth
                    size="small"
                    sx={{
                      with: "100%",
                    }}
                  >
                    <Select
                      id=""
                      value={filterState.status}
                      onChange={HandleStatusChange}
                    >
                      {listOfStatus.map((name: any) => (
                        <MenuItem value={name}>{name}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              <Grid borderBottom={theme.border?.smallGrey} mt={5}>
                <Typography
                  sx={{
                    fontFamily: theme.font?.fontFamily.primary,
                    fontSize: theme.font?.fontSize.medium,
                    fontWeight: theme.font?.fontWeight.thick,
                  }}
                >
                  Role
                </Typography>
                <Grid
                  gap={2}
                  mt={2}
                  display={"flex"}
                  sx={{
                    width: "80%",
                  }}
                >
                  <FormControl
                    fullWidth
                    size="small"
                    sx={{
                      with: "100%",
                    }}
                  >
                    <Select
                      id=""
                      value={filterState.userRole}
                      onChange={HandleRoleChange}
                    >
                      {roles.map((name: any) => (
                        <MenuItem value={name}>{name}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions sx={{ pr: 4, gap: 1, pt: 3 }}>
            <Button
              sx={{ ...buttonStyles.outlinedSecondary }}
              onClick={resetFilterState}
            >
              Reset
            </Button>
            <Button
              sx={{ ...buttonStyles.containedSecondary }}
              onClick={applyShopUserFilter}
            >
              Apply
            </Button>
          </DialogActions>
        </Grid>
      </Dialog>
      <Grid display={"flex"} justifyContent={"space-between"} px={4} py={3}>
        {getMerchantReceiptPermission("create") && (
          <Button
            sx={{ ...buttonStyles.textSecondary }}
            onClick={() => {
              setAddShopUser(true);
            }}
          >
            Add Shop User
          </Button>
        )}

        <Grid display={"flex"} gap={3}>
          <SearchInput
            HelpTip={SearchToolTip.MerchantShopUser}
            onCallBack={handleSearch}
            ref={searchInputRef}
          />
          <Button
            variant="text"
            startIcon={
              filterActive ? (
                <FilterAltIcon sx={{ color: theme.color?.secondary }} />
              ) : (
                <FilterAltOutlinedIcon />
              )
            }
            sx={{
              color: theme.color?.newFilterGrey,
              textTransform: "capitalize",
            }}
            onClick={() => {
              setOpenFilter(true);
            }}
          >
            Filter
          </Button>
        </Grid>
      </Grid>
      <Grid p={2}>
        <InfiniteTable
          header={columns}
          contentItems={data}
          hasMoreRecords={lastKey !== null}
          fetchMoreData={() => bindSearchAndFilter(true)}
          isInitialLoading={data.length === 0 && loading}
          totalRecords={totalCount}
        />
      </Grid>
    </Grid>
  );
};

export default ViewMerchantShopUser;
